(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["if-customer-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('if-customer-stories')) {
  customElements.define('if-customer-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.dialog = this.querySelector('dialog');
      this.motion = this.querySelector('[data-motion]');
      this.motion.hidden = false;
      this.lanes = Array.from(this.querySelectorAll('[data-lane]')).map(viewport => {
        const track = viewport.firstElementChild;
        const originals = Array.from(track.children);
        const lane = {viewport, track, originals, distance:0, position:0, reverse:viewport.hasAttribute('data-reverse')};
        originals.forEach(card => {
          const copy = card.cloneNode(true);
          copy.setAttribute('aria-hidden','true');
          copy.dataset.clone = '';
          copy.querySelectorAll('a,button,[tabindex]').forEach(control => control.setAttribute('tabindex','-1'));
          track.append(copy);
        });
        const controls = viewport.closest('.if-cs-row').querySelector('.if-cs-controls');
        controls.hidden = false;
        controls.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          this.setPaused(true);
          const direction = button.hasAttribute('data-next') ? 1 : -1;
          viewport.scrollBy({left: direction * (originals[0].getBoundingClientRect().width + 20), behavior:this.reducedMotion.matches ? 'instant' : 'smooth'});
        },{signal});
        viewport.addEventListener('pointerdown', () => this.setPaused(true), {signal,passive:true});
        viewport.addEventListener('wheel', () => this.setPaused(true), {signal,passive:true});
        return lane;
      });
      this.resize = new ResizeObserver(() => {
        this.lanes.forEach(lane => {
          const copy = lane.track.querySelector('[data-clone]');
          lane.distance = copy.offsetLeft - lane.originals[0].offsetLeft;
          if (!lane.initialized && lane.distance > 0) {
            lane.viewport.scrollLeft = lane.reverse ? lane.distance : 0;
            lane.initialized = true;
          }
          lane.position = lane.viewport.scrollLeft;
        });
      });
      this.lanes.forEach(lane => this.resize.observe(lane.viewport));
      this.intersection = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting);
        if (this.inView) this.start(); else this.stop();
      });
      this.intersection.observe(this);
      this.motion.addEventListener('click', () => this.setPaused(!this.paused), {signal});
      this.reducedMotion.addEventListener('change', () => this.setPaused(this.reducedMotion.matches), {signal});
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start(), {signal});
      this.addEventListener('click', event => {
        const video = event.target.closest('[data-video]');
        if (!video || !this.dialog.showModal || !/^[a-zA-Z0-9_-]{11}$/.test(video.dataset.video)) return;
        event.preventDefault();
        this.setPaused(true);
        this.opener = video;
        this.querySelector('[data-dialog-title]').textContent = video.dataset.title;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${video.dataset.video}?autoplay=1&rel=0`;
        iframe.title = video.dataset.title;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.querySelector('.if-cs-player').replaceChildren(iframe);
        this.dialog.showModal();
      },{signal});
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => {if (event.target === this.dialog) this.dialog.close();}, {signal});
      this.dialog.addEventListener('close', () => {
        this.querySelector('.if-cs-player').replaceChildren();
        this.opener?.focus({preventScroll:true});
      },{signal});
      this.updateControl();
    }
    setPaused(value) {
      this.paused = value;
      this.lanes.forEach(lane => {lane.position = lane.viewport.scrollLeft;});
      this.updateControl();
      if (value) this.stop(); else this.start();
    }
    updateControl() {
      this.motion.textContent = this.paused ? this.dataset.resume : this.dataset.pause;
      this.motion.setAttribute('aria-pressed', String(this.paused));
    }
    start() {
      if (this.frame || this.paused || !this.inView || document.hidden) return;
      this.last = 0;
      const tick = time => {
        const elapsed = this.last ? Math.min(time-this.last,50) : 0;
        this.last = time;
        this.lanes.forEach(lane => {
          if (!lane.distance || lane.viewport.matches(':hover') || lane.viewport.contains(document.activeElement)) {
            lane.position = lane.viewport.scrollLeft;
            return;
          }
          lane.position += elapsed * (lane.reverse ? -.021 : .026);
          if (lane.position >= lane.distance) lane.position -= lane.distance;
          if (lane.position < 0) lane.position += lane.distance;
          lane.viewport.scrollLeft = lane.position;
        });
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    stop() {cancelAnimationFrame(this.frame);this.frame = 0;}
    disconnectedCallback() {
      this.stop();this.abort?.abort();this.resize?.disconnect();this.intersection?.disconnect();
      this.querySelectorAll('[data-clone]').forEach(card => card.remove());
      this.active = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
